import { css } from '@emotion/react';
import theme from '@styles/theme';
import React from 'react';

interface IDescriptionProps {
  topic: string;
  targetAge: string;
  oneLineDesc: string;
  isWebNovel?: boolean;
}

const Description = ({
  topic,
  targetAge,
  oneLineDesc,
  isWebNovel,
}: IDescriptionProps) => {
  return (
    <div css={container}>
      <p className="one-line-desc">{oneLineDesc}</p>

      <span className="topic">{topic}</span>
      <span className="split-point"> • </span>
      <span className="target-age">{targetAge}</span>
    </div>
  );
};

const container = css`
  padding: 0.75em 0;

  .badge {
    position: relative;
    top: -1px;

    display: inline-flex;
    margin-right: 8px;
    border-radius: 3px;
    background-color: ${theme.colors.primary700};
    padding: 0.1875em 0.375em;

    font-weight: 600;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: -0.3px;

    color: ${theme.colors.white};
  }

  .topic,
  .target-age {
    color: ${theme.colors.primary300};
    font: ${theme.font.body.caption};
  }

  .split-point {
    color: ${theme.colors.primary300};
    font: ${theme.font.body.caption};
  }

  .one-line-desc {
    padding-top: 0.5em;
    padding-bottom: 0.5rem;
    color: ${theme.colors.gray500};
    font: ${theme.font.body2Normal};
    line-height: 20px;
    white-space: pre-line;
  }
`;

export default Description;
